/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedDTO_ProviderDTO_ } from '../models/PaginatedDTO_ProviderDTO_'
import type { ProviderCreateDTO } from '../models/ProviderCreateDTO'
import type { ProviderDTO } from '../models/ProviderDTO'
import type { ProviderPatchDTO } from '../models/ProviderPatchDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenProvidersService {
    /**
     * Index
     * @returns PaginatedDTO_ProviderDTO_ Successful Response
     * @throws ApiError
     */
    public static indexProvidersGet({
        page = 1,
        limit = 10,
        sort,
        search
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
        /**
         * Search term
         */
        search?: string | null
    }): CancelablePromise<PaginatedDTO_ProviderDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/providers',
            query: {
                page: page,
                limit: limit,
                sort: sort,
                search: search
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create
     * @returns ProviderDTO Successful Response
     * @throws ApiError
     */
    public static createProvidersPost({ requestBody }: { requestBody: ProviderCreateDTO }): CancelablePromise<ProviderDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/providers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get
     * @returns ProviderDTO Successful Response
     * @throws ApiError
     */
    public static getProvidersProviderIdGet({ providerId }: { providerId: string }): CancelablePromise<ProviderDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/providers/{provider_id}',
            path: {
                provider_id: providerId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Patch
     * Update a provider.
     * Automatically logs all field changes to the audit trail.
     * @returns ProviderDTO Successful Response
     * @throws ApiError
     */
    public static patchProvidersProviderIdPatch({
        providerId,
        requestBody
    }: {
        providerId: string
        requestBody: ProviderPatchDTO
    }): CancelablePromise<ProviderDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/providers/{provider_id}',
            path: {
                provider_id: providerId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete
     * Delete a provider.
     * Automatically logs deletion to the audit trail.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteProvidersProviderIdDelete({ providerId }: { providerId: string }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/providers/{provider_id}',
            path: {
                provider_id: providerId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
